import { useState } from 'react';

import { CurrentCarPlaceInfoType } from '../../feature/type/CurrentCarPlaceInfoType';

/**
 * 車両現在位置一覧の状態管理用カスタムフック
 */
export const useStateCurrentCarPlace = () => {
	const [currentCarPlaceList, setCurrentCarPlaceList] = useState<CurrentCarPlaceInfoType[]>([]); // 取得した車両現在位置一覧の管理

	return {
		currentCarPlaceList,
		setCurrentCarPlaceList,
	};
};
